import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from 'react';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Input from '@mui/material/Input';
import { Typography, FormControl, InputLabel, Select, MenuItem, OutlinedInput, TextField, SelectChangeEvent, Stack } from '@mui/material';
import { createIThreat, deleteIThreat, updateIThreat } from '../../helper'
import DialogBoxComponent from "../../../../../components/DialogBoxComponent";
import { EditThreat } from '../../modal';
import { useUserContext } from '../../../../../context/auth/UserContext';

interface DialogBoxFolderProps {
  openDialogBox: boolean;
  dialogTitle?: string;
  dialogBody?: string;
  dialogAction?: string;
  dialogActionCancel?: string;
  threatSourceList?: string[];
  row?: any | null;
  handleFunction?: (field1Name: string) => void;
  handleCancel?: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const getTypographyStyles = () => ({
  //Typography styles
  fontWeight: 400,
  fontSize: '14px',
  fontStyle: 'italic',
  opacity: 0.5
});

const DialogBoxForm: React.FC<DialogBoxFolderProps> = (props) => {
  const [open, setOpen] = useState(false);
  const { userId, companyProfileID } = useUserContext();
  const [dialogTitle, setDialogTitle] = useState<string>("");
  const [dialogAction, setDialogAction] = useState<string>("");
  const [dialogActionCancel, setDialogActionCancel] = useState<string>("");
  const [threatSourceListProps, setThreatSourceListProps] = React.useState<any[]>([])
  const [field1Name, setField1Name] = useState<string>("");
  const [validationMessage, setValidationMessage] = useState<string>("")


  useEffect(() => {
    setOpen(props.openDialogBox);
    setDialogTitle(props.dialogTitle || "");
    setDialogAction(props.dialogAction || "");
    setThreatSourceListProps(props.threatSourceList || []);
    setDialogActionCancel(props.dialogActionCancel || "");
    setField1Name(props.row?.threatName ?? "")
  }, [props.openDialogBox, props.dialogTitle, props.dialogAction, props.dialogActionCancel]);

  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });
  const handleClose = () => {
    if (props.handleCancel) {
      props.handleCancel();
    }
    setField1Name("");
    setValidationMessage("")

  };
  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const isField1NameExists = threatSourceListProps.some(
      (threatSource) => threatSource.threatName.toLowerCase() === field1Name.toLowerCase()
    );

    if (isField1NameExists) {
      // If the name exists, display validation message
      setValidationMessage(`${field1Name} already exists.`);
      return;
    } else {
      setValidationMessage(""); // Clear the message if the name doesn't exist
    }
    if (props.row === null) {
      AddThreatSource(field1Name);
    }
    else {
      // setField1Name(props.row?.threatName)
      UpdateThreatSource(props.row?.threatID, field1Name);
    }
  };
  //#region  Api call functions
  const AddThreatSource = async (threatName: string | "") => {

    const date = new Date();
    const payload = {
      threatName: threatName,
      createDate: date,
      companyProfileID: companyProfileID,
      createdBy: userId,
    };
    const res = await createIThreat(payload);
    handleClose();
    if (res.succeeded === true) {

      setDialogState({
        title: "Success",
        body: "Threat Source successfully created",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: res.error,
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }

  }
  const UpdateThreatSource = async (threatId: number, threatName: string | "") => {

    const date = new Date();
    const payload: EditThreat = {
      threatID: threatId,
      threatName: threatName,
      updateDate: date,
      companyProfileID: companyProfileID,
      updatedBy: props.row?.updatedBy,
      isDeleted: false
    };
    const res = await updateIThreat(payload);
    handleClose();
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: "Threat Source successfully Updated",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: res.error,
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }

  }
  const handleCloseDialog = () => {
    if (dialogState.title !== "Error") {

      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    } else {
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    }
  };



  //#endregion

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        keepMounted
        PaperProps={{
          component: 'form',
          onSubmit: handleFormSubmit
        }}
        fullWidth
        maxWidth="xs"
        sx={{ borderRadius: "40px" }}
      >
        <DialogTitle id="alert-dialog-title">
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <Stack direction="column" spacing={2} >
            <div>
              <Typography sx={getTypographyStyles}>
                Threat Source Name </Typography>
              <TextField
                autoFocus
                required
                margin="dense"
                fullWidth
                size='small'
                variant="outlined"
                value={field1Name}
                onChange={(e) => setField1Name(e.target.value)}
                sx={{ backgroundColor: "#E4EBEF" }}
              />
              {validationMessage && (
                <Typography variant="body2" color="error">
                  {validationMessage}
                </Typography>
              )}
            </div>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size='small' variant="contained" onClick={handleClose} sx={{
            backgroundColor: "rgba(0, 102, 255, 0.1)",
            color: "#0066FF",
            '&:hover': {
              bgcolor: "#0066ff2e",
            },
          }}>
            {dialogActionCancel}
          </Button>
          <Button size='small' variant='contained' type="submit" sx={{
            backgroundColor: "#0066FF",
            '&:hover': {
              bgcolor: "#0556d0",
            },
          }}>{dialogAction}</Button>
        </DialogActions>
      </Dialog>
      {<DialogBoxComponent
        openDialogBox={dialogState.openSuccessDialogBox}
        dialogTitle={dialogState.title}
        dialogAction={dialogState.action}
        dialogBody={dialogState.body}
        handleFunction={handleCloseDialog}
      />}
    </React.Fragment>
  );
};

export default DialogBoxForm;
